import React, { useEffect, useRef, useState } from "react";
import "./Testimonials.css";
import Common_Title_1 from "../../common/common_components/common_title_1/Common_Title_1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/grid";
import { Grid } from "swiper/modules";
import Testimonial_Card from "./testimonial_card/Testimonial_Card";
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { useDispatch, useSelector } from "react-redux";
import { AllTestimonials, GurujiWisdom } from "../../../features/admin/common/Slice";

const Testimonials = () => {
  const swiperRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const dispatch = useDispatch();
  const all_testimonials = useSelector((state) => state.common.all_testimonials);

  useEffect(() => {
    dispatch(AllTestimonials());
  }, [dispatch])

  return (
    <section className="Testimonials">
      <div className="container">
        <div className="main_content_div">
          <div className="row ">
            <div className="col-xl-3 col-lg-3 ">
              <div className="left_side">
                <div className="swiper_btn_div">
                  <Common_Title_1
                    titleText="TESTIMONIALS"
                    subText="What Our Sadhaks Say"
                  />

                  <div className="silder_btn">
                    <div className="back_btn_holder" onClick={() => handleMainSliderClick("prev")}>
                      <div
                        className="back_btn"

                      >
                        <FontAwesomeIcon icon={faAngleLeft} className="icon" />
                      </div>
                    </div>
                    <div className="back_btn_holder" onClick={() => handleMainSliderClick("next")}>
                      <div
                        className="back_btn"

                      >
                        <FontAwesomeIcon icon={faAngleRight} className="icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 col-lg-9">
              <Swiper
                ref={swiperRef}
                spaceBetween={15}
                slidesPerView={2}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay]}

                onSwiper={setSwiperInstance}

                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                  },
                  420: {
                    slidesPerView: 1.5,
                  },
                  768: {
                    slidesPerView: 2.2,
                  },
                  1200: {
                    slidesPerView: 2.2,
                  },
                  1400: {
                    slidesPerView: 2.5,
                  },
                }}
              >
                {all_testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Testimonial_Card testimonial={testimonial} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
